<div class="goal-div">
  <ngx-spinner aria-hidden="true"></ngx-spinner>
  <span class="sr-only" aria-live="polite" role="status">{{ loadingMessage }}</span>
  @if (!isLoading) {
  @if (userCareerGoal == "") {
    <button
      mat-flat-button
      type="button"
      class="btn goal-btn"
      (click)="setCareerGoal()"
    >
      Set as Career Goal
    </button>
    <p class="goal-desc">
      Set a career goal to unlock your action plan. 
      See the skills and steps to get there.
    </p>
  } @else if (userCareerGoal == onetCode) {
    <button
      mat-flat-button
      type="button"
      class="btn goal-btn-set"
      (click)="unsetCareerGoal()"
    >
      <img 
        src='/assets/icons/star-black.svg' 
        alt="star"
        class="star-icon" 
      />
      <p>My Career Goal</p>
    </button>
    <p class="goal-desc">
      Your career action plan is available on the 
      <a class="plan-link underline" routerLink="/build-plan">Build Your Plan</a> 
      page
    </p>
  } @else {
    <button
      mat-flat-button
      type="button"
      class="btn replace-goal-btn"
      (click)="replaceCareerGoal()"
    >
      Replace as Career Goal
    </button>
    <p class="goal-desc">
       Your career action plan is available on the 
      <a class="plan-link underline" routerLink="/build-plan">Build Your Plan</a> 
      page
    </p>
  }
  }
</div>